import React from 'react';

import styled from '@emotion/styled';

interface PageHeaderProps {
  title: string;
  description?: string;
  className?: string;
  customComp?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  description,
  className,
  customComp,
}) => {
  return (
    <Container className={className}>
      <TextArea>
        <HeaderTitle>{title}</HeaderTitle>
        {description && <HeaderDescription>{description}</HeaderDescription>}
      </TextArea>
      {customComp && <div>{customComp}</div>}
    </Container>
  );
};

export default PageHeader;

const Container = styled.div`
  /* border: 1px solid red; */
  display: flex;
  /* flex-direction: column; */
  gap: 16px;
  justify-content: space-between;

  padding-bottom: 28px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.borderColor};

  &.borderless {
    border-bottom: none;
  }

  &.no-bottom-padding {
    padding-bottom: 0px;
  }
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const HeaderTitle = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 22px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const HeaderDescription = styled.div`
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
  line-height: 14px;
`;
